import colors from "./Color";
import typeScale from "./TypeScale";

const theme = {
  colors,
  typeScale,
};

export default theme;
